import React from "react";
import "./accessibility.css";

const browsers = ["פיירפוקס", "כרום", "אקספלורר 9 ומעלה", "אופרה"];

const menuFeatures = [
  "כפתור התאמת האתר ותגיות האתר עבור מכשירי עזר וטכנולוגיות עבור בעלי מוגבלויות",
  "כפתור איפשור ניווט בעזרת מקשי המקלדת בין הקישורים שבאתר",
  "כפתור השבתת הבהובים ו/או אלמנטים נעים על המסך",
  "כפתור איפשור מצב מונוכרום שחור לבן עבור עיוורי צבעים",
  "כפתור ספיה (גוון חום)",
  "כפתור שינוי ניגודיות גבוהה",
  "כפתור שחור צהוב",
  "כפתור היפוך צבעים",
  "כפתור המדגיש בצורה ברורה את כל תגי הכותרות המופיעים באתר",
  "כפתור המדגיש בצורה ברורה את כל הקישורים המופיעים באתר",
  "כפתור המציג את התיאור החלופי של כל התמונות המופיעות באתר במעבר עכבר",
  "כפתור המציג תיאור קבוע של התמונות באתר",
  "כפתור ביטול שימוש בגופן קריא",
  "כפתור הגדלת גודל הגופנים באתר",
  "כפתור הקטנת גודל הגופנים באתר",
  "כפתור הגדלת כל התצוגה לכ־200%",
  "כפתור הקטנת כל התצוגה לכ־70%",
  "כפתור הגדלת סמן העכבר",
  "כפתור הגדלת סמן העכבר ושינוי צבעו לשחור",
  "כפתור מצב קריאת האתר",
  "כפתור המציג את הצהרת הנגישות",
  "כפתור איפוס המבטל את הנגישות",
  "כפתור שליחת משוב נגישות",
  "כפתור שינוי שפת הסרגל והצהרת הנגישות בהתאם",
];

const keyboardShortcuts = [
  "מקש Esc יפתח ויסגור את סרגל הנגישות",
  "מקש Ctrl + יגדיל את הטקסט באתר",
  "מקש Ctrl – יקטין את הטקסט באתר",
  "מקש Ctrl 0 יחזיר את האתר לגדלו המקורי",
  "מקש רווח (SPACE) יוריד את האתר כלפי מטה",
  "מקש F11 יגדיל את המסך לגודל מלא – לחיצה נוספת תקטין אותו חזרה",
];

function Accessibility() {
  return (
    <main className="accessibility-page" dir="rtl">
      <h1>הצהרת נגישות</h1>

      <section>
        <h2>הנגישות באתר מותאמת לדפדפנים המובילים:</h2>
        <ul>
          {browsers.map((browser) => (
            <li key={browser}>{browser}</li>
          ))}
        </ul>
      </section>

      <section>
        <h2>מדריך למשתמש בתפריט:</h2>
        <ul>
          {menuFeatures.map((feature) => (
            <li key={feature}>{feature}</li>
          ))}
        </ul>
      </section>

      <section>
        <h2>
          בסרגל הנגישות יש 2 סוגים של הגדלות לנוחיותכם, אך אם תרצו להגדיל עוד את
          האותיות תוכלו להשתמש בפונקציות המקלדת הבאות:
        </h2>
        <ul>
          {keyboardShortcuts.map((shortcut) => (
            <li key={shortcut}>{shortcut}</li>
          ))}
        </ul>
      </section>

      <section>
        <h2>למען הסר ספק:</h2>
        <p>
          אנחנו מחויבים להפוך את אתרינו לנגיש לכלל האנשים, בעלי יכולות ובעלי
          מוגבלויות. באתר זה תוכלו למצוא את הטכנולוגיה המתאימה לצרכים שלכם. אתר
          זה הנו אתר שמיש לכלל האוכלוסייה ברובו ובהשתדלות מקסימאלית.
        </p>
        <p>
          ייתכן ותמצאו אלמנטים שאינם מונגשים כי טרם הונגשו או שלא נמצאה
          טכנולוגיה מתאימה ולצד זה אנו מבטיחים כי מתבצעים מרב המאמצים לשפר
          ולהנגיש ברמה גבוהה ובלי פשרות.
        </p>
        <p>
          במידה ונתקלתם בקושי בגלישה באתר וצפייה בתוכנו אנו מתנצלים ונשמח מאוד
          כי תפנו את תשומת ליבנו לכך.
        </p>
      </section>

      <section>
        <h2>נתקלת בבעיה באתר?</h2>
        <p>
          רשמו לנו על התקלות בהם נתקלתם עם פירוט מורחב ככל שניתן על מנת שנוכל
          לטפל בבעיה במהירות האפשרית.
        </p>

        <h3>בפניה על תקלה נא לציין:</h3>
        <ul>
          <li>תיאור הבעיה</li>
          <li>באיזה דף גלשתם?</li>
          <li>סוג הדפדפן</li>
          <li>סוג הטכנולוגיה המסייעת (במידה והשתמשתם)</li>
        </ul>

        <p>אנו נטפל בבעיה בהקדם עם פרטים על טיפולה!</p>
      </section>

      <section>
        <h2>הסדרי נגישות פיזיים:</h2>
        <p>גישה- אין גישה לבעלי מוגבלות או אדם אחר, אני מגיע אליכם בלבד.</p>
        <p>
          אנו נוקטים באמצעים ומשאבים רבים בכדי לספק לכלל לקוחותיה שירות שוויוני,
          מקצועי ונגיש.
        </p>
        <p>
          עם זאת חשוב לציין כי ייתכן וימצאו אלמנטים מסוימים שאינם מונגשים בצורה
          מלאה או נמצאים בתהליכי הנגשה לאנשים עם מוגבלות.
        </p>
      </section>

      <section>
        <h2>נתקלתם ברכיב שאינו נגיש באתר?</h2>
        <p>
          פנו אלינו ואנו מבטיחים לבדוק לשפר אותו בהקדם האפשרי וכמובן להעניק לכם
          את השירות הטוב ביותר בצורה מהירה, אישית ובהתאם לשביעות רצונכם.
        </p>
      </section>

      <section className="accessibility-contact">
        <h2>לבירורים נוספים:</h2>
        <p>בכל שאלה בנושא נגישות ניתן לפנות לאחראי הנגישות:</p>

        <p>
          <strong>שם:</strong> עומר מור
        </p>

        <p>
          <strong>בטלפון: </strong>
          <a href="tel:0544440136">0544440136</a>
        </p>

        <p>
          <strong>דואר אלקטרוני: </strong>
          <a href="mailto:omer6688@gmail.com">omer6688@gmail.com</a>
        </p>
      </section>

      <p className="accessibility-date">הצהרת הנגישות עודכנה בתאריך 01.01.24</p>
    </main>
  );
}

export default Accessibility;
